<template>
    <div>
        <Naw :noInput="true"></Naw>
        <b-modal
            id="privacyModal"
            :title-html="`<i class='far fa-file-contract'></i>&nbsp;&nbsp;${title}`"
            size="lg"
            ok-title="Akkoord met privacyverklaring"
            ok-variant="success"
            @ok="privacyOk"
            cancel-title="Niet akkoord"
            cancel-variant="danger"
            @cancel="confirmCloseModal"
            @close="modalRejectClosure"
            @hide="modalRejectClosure"
            hide-header-close
            no-close-on-esc
            no-close-on-backdrop
        >
            <p v-html="content">

            </p>
        </b-modal>

        <b-modal
          id="confirmCloseModal"
          title-html="<i class='far fax fa-check'></i>&nbsp;Bevestig afmelden"
          size="lg"
          ok-title="Ja"
          ok-variant="danger"
          @ok="confirmCloseJa"
          cancel-title="Nee"
          cancel-variant="primary"
          @cancel="confirmCloseNee"
          hide-header-close
        >
        <b-row>
          <b-col sm="12">
              <p>
                Let op, als u niet akkoord gaat met de privacy voorwaarden, dan schrijft u automatisch uw woningzoekende profiel uit.
              </p>
            </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
              <p>
                Weet je het zeker? Ja/Nee
              </p>
            </b-col>
        </b-row>
        </b-modal>

        <b-modal
                id="privacyRejectModal"
                title-html="<i class='fa fa-exclamation'></i>&nbsp;&nbsp;Weet u het zeker?"
                size="lg"
                ok-title="Terug"
                ok-variant="success"
                @ok="rejectOk"
                cancel-title="Ik ga definitief niet akkoord"
                cancel-variant="danger"
                @cancel="rejectCancel"
                @close="modalRejectClosure"
                @hide="modalRejectClosure"
                hide-header-close
                no-close-on-esc
                no-close-on-backdrop
        >
            <p>
                Om gebruik te kunnen maken van {{skin.region}} moet u akkoord gaan met onze privacyverklaring en disclaimer.
                Indien u definitief niet akkoord gaat met onze privacyverklaring en disclaimer, <strong>wordt u uitgeschreven.</strong>
            </p>
            <p v-if="skin.paid">
                <strong>Let op:</strong> Bij uitschrijving volgt er geen teruggave van het inschrijfgeld.
            </p>
        </b-modal>
    </div>
</template>

<script>
  import Naw from './Naw'
  import {privacyService, registrationService} from '../../_services'
  import { accountService } from '../../_services/account.service'
  export default {
    components: { Naw },
    data: () => {
      return {
        title: 'Privacyverklaring',
        content: '',
        skin: {
          region: process.env.VUE_APP_REGION,
          paid: process.env.VUE_APP_PAID === 'true'
        }
      }
    },
    name: 'Privacy',
    mounted() {
        privacyService.get().then((data) => {
          this.title = data.title
          this.content = data.content
          this.$bvModal.show('privacyModal')
        })
        this.$emit('validated', true)
    },
    activated () {
      this.$bvModal.show('privacyModal')
    },
    methods: {
      confirmCloseModal () {
        this.$bvModal.show('confirmCloseModal')
      },
      confirmCloseJa () {
        this.$bvModal.hide('confirmCloseModal')
        this.rejectCancel()
      },
      confirmCloseNee () {
        this.$bvModal.hide('confirmCloseModal')
      },
      privacyOk() {
        this.$bvModal.hide('privacyModal')
        registrationService.postPrivacy()
        this.$emit('registrationStepNext')
      },
      privacyCancel() {
        this.$bvModal.show('privacyRejectModal')
      },
      rejectOk() {
        this.$bvModal.hide('privacyRejectModal')
      },
      rejectCancel() {
        accountService.remove('62DBBC23-2025-43FE-B064-BC914BDFB43B').then(() => {
          window.location.href = '../logout'
        })
      },
      modalRejectClosure(evnt) {
        if(evnt.trigger !== 'ok') {
          evnt.preventDefault()
        }
      }
    }
  }
</script>

<style scoped>

</style>